import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';
import {memo} from 'react';

const PrinterDeviceIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path
        fill="#100E3A"
        d="M16.771 5.312h-.834V3.125A.938.938 0 0 0 15 2.187H5a.937.937 0 0 0-.938.938v2.187H3.23C1.966 5.312.937 6.294.937 7.5v6.25a.937.937 0 0 0 .938.938h2.188v2.187a.937.937 0 0 0 .937.938h10a.938.938 0 0 0 .938-.938v-2.188h2.187a.938.938 0 0 0 .938-.937V7.5c0-1.206-1.029-2.188-2.292-2.188ZM5.937 4.062h8.125v1.25H5.938v-1.25Zm8.125 11.875H5.938v-2.5h8.125v2.5Zm3.126-3.124h-1.25V12.5a.937.937 0 0 0-.938-.938H5a.937.937 0 0 0-.938.938v.313h-1.25V7.5c0-.17.191-.313.417-.313H16.77c.226 0 .416.143.416.313v5.313Zm-1.25-3.438a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
      />
    </Icon>
  );
};

export default memo(PrinterDeviceIcon);
